import React from 'react'

export const Breadcrumb = React.memo(({pbData})=> {
    return (
        <ol className="breadcrumbs">
            {
                pbData?.homewardPathSegments?.length > 0 &&
                pbData?.homewardPathSegments.map((breadcrumbs, index) =>
                    <li key={index}>{breadcrumbs.url ? <a href={breadcrumbs.url}>{breadcrumbs.displayName}</a> : breadcrumbs.displayName}</li>
                )
            }
        </ol>
    )
})